import { pr } from '@/utils/pxToRem';
import { Typography, Stack } from '@mui/material';
import React from 'react';
import { style } from '@/styles/globals';
import Image from 'next/image';
import { loaderImageVex } from '@/utils/loadImageSeoVex';

const SocialNetwork = ({ lang }: any) => (
  <Stack spacing={pr`16px`}>
    <Typography
      component="div"
      sx={{
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '30px',
        color: `${style.color.black1}`,
      }}
    >
      {lang?.footer?.followUs.title || 'Theo dõi chúng tôi trên'}
    </Typography>
    <Stack
      justifyContent="flex-start"
      direction="row"
      spacing={pr`20px`}
    >
      <div>
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SN/facebook_color.svg"
          alt="logo"
          width="24px"
          height="24px"
          objectFit="contain"
        />
      </div>
      <div>
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SN/bxl_youtube.svg"
          alt="logo"
          width="24px"
          height="24px"
          objectFit="contain"
        />

      </div>
      <div>
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SN/GooglePlusCircle_color.svg"
          alt="logo"
          width="24px"
          height="24px"
          objectFit="contain"
        />
      </div>
    </Stack>
  </Stack>
);

export default SocialNetwork;
